module.exports = __webpack_public_path__ + "static/media/klover.61004a38.png";